import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import he from "he";
import "react-quill/dist/quill.snow.css";

import Button from "../main/button";
import Input from "../main/input";
import Select from "../main/select";

import fetch from "../../utils/fetch";

import { useModalDataStore } from "../../store/modalData";
import { useClientsDataStore } from "../../store/clientsData";
import { useActiveClientIdStore } from "../../store/activeClientId";
import { useActiveClientStore } from "../../store/activeClient";
import { useStatusStore } from "../../store/statusData";

interface Props {}

const Modal: React.FC<Props> = () => {
    const clients = useClientsDataStore<any>((s) => s.clients);
    const modalData = useModalDataStore<any>((s) => s.modalData);
    const setModalData = useModalDataStore<any>((s) => s.setModalData);
    const setActiveClientId = useActiveClientIdStore<any>((s) => s.setActiveClientId);
    const setActiveClient = useActiveClientStore<any>((s) => s.setActiveClient);
    const [search, setSearch] = useState<string>("");
    const status = useStatusStore<any>((s) => s.status);
    const setStatus = useStatusStore<any>((s) => s.setStatus);

    useEffect(() => {
        if (status === "ringing") {
            setActiveClientId(0);
            setActiveClient({});
        }
        setStatus("search");
        // console.log(modalData);
        if (modalData?.start_call?.client_id && modalData?.start_call?.did && modalData?.start_call?.cli && modalData?.start_call?.sid) {
            window.history.replaceState(null, "", `?start_call_did=${modalData.start_call.did}&start_call_cli=${modalData.start_call.cli}&start_call_sid=${modalData?.start_call?.sid}`);
            setTimeout(() => {
                setActiveClient({});
                setActiveClientId(Number(modalData.start_call.client_id));
                setModalData({});
                setStatus("search");
                // modalData.start_call.did
            }, 700);
        }
    }, []);

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 mb-4">
                        <h5 className="text-center">Search clients</h5>
                    </div>

                    <div className="col-12 mb-4">
                        <Input
                            container={false}
                            className="input-small"
                            name="destination"
                            placeholder="Destination"
                            type="text"
                            updateChange={(v) => {
                                setSearch(v);
                            }}
                            autoFocus
                        />
                        <div>
                            {clients.map((a: any, i: number) => {
                                if (search === "") return <React.Fragment key={i} />;
                                if (a.name.toLowerCase().includes(search.toLowerCase()))
                                    return (
                                        <div
                                            key={i}
                                            className="my-2 p-2 card cursor-pointer"
                                            onClick={() => {
                                                setActiveClient({});
                                                setActiveClientId(Number(a.id));
                                                setModalData({});
                                                setStatus("search");
                                            }}>
                                            {he.decode(a.name)}
                                        </div>
                                    );

                                return <React.Fragment key={i} />;
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Modal;
